import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var container = /*#__PURE__*/css(["margin:0 auto;position:relative;", ";", ";", ";", ";"], mediaQuery({
  min: minBreakpoints.XL
}, css(["max-width:", ";"], pxToRem(684))), mediaQuery({
  min: minBreakpoints.L,
  max: maxBreakpoints.L
}, css(["max-width:", ";"], pxToRem(388))), mediaQuery({
  min: minBreakpoints.M,
  max: maxBreakpoints.M
}, css(["max-width:", ";min-width:", ";"], pxToRem(386), pxToRem(328))), mediaQuery({
  max: maxBreakpoints.M
}, css(["padding:0 ", ";"], pxToRem(spacing.xs))));